import {
  FORSUBMIT,
  CREATE_INVOICE,
  DELETE_INVOICE,
  UPDATE_INVOICE,
  GET_INVOICE,
  CLEAR_INVOICE,
  TOGGLE_AS_PAID
} from '@hobs/constants/invoices';
import { actionCreator } from './utils/utils';

export const getForSubmit = body =>
  actionCreator(
    'StatementOfRequirements/InvoiceReference/ForSubmit',
    FORSUBMIT,
    { body, method: 'POST' }
  );

export const createInvoice = body =>
  actionCreator(
    'StatementOfRequirements/InvoiceReference/InvoiceServiceRequests',
    CREATE_INVOICE,
    {
      body: body,
      method: 'POST'
    }
  );

export const deleteInvoice = invoiceReferenceId =>
  actionCreator(
    `StatementOfRequirements/InvoiceReference/${invoiceReferenceId}`,
    DELETE_INVOICE,
    {
      method: 'DELETE'
    }
  );

export const updateInvoice = body =>
  actionCreator(
    'StatementOfRequirements/InvoiceReference/Update',
    UPDATE_INVOICE,
    {
      body: body,
      method: 'PUT'
    }
  );

export const getInvoice = serviceRequestId =>
  actionCreator(
    `StatementOfRequirements/InvoiceReference/${serviceRequestId}`,
    GET_INVOICE
  );

export const clearInvoices = () => {
  return dispatch => {
    dispatch({ type: CLEAR_INVOICE.SUCCESS });
  };
};

export const toggleAsPaid = body =>
  actionCreator(
    'StatementOfRequirements/InvoiceReference/InvoiceAsPaid',
    TOGGLE_AS_PAID,
    {
      body: body,
      method: 'POST'
    }
  );
